import { API_BASE_URL } from "../urls.api";

export const getAddressSuggestionsUrl = (address: string, countryName: string) =>
  `${API_BASE_URL}/address-suggestions?address=${address}&countryName=${countryName}`;

export const geocodeAddressUrl = (address: string, countryName: string) =>
  `${API_BASE_URL}/address-suggestions/geocode?address=${encodeURIComponent(address)}&countryName=${encodeURIComponent(countryName)}`;
